import { useQuery } from '@tanstack/react-query';
import { queryKeys, offeringsService } from '@v2/services';

export const useBitwerxOfferingDetails = (offeringId: string | null) => {
  const query = useQuery({
    queryKey: queryKeys.offerings.bitwerx.detail(offeringId!),
    queryFn: () => offeringsService.getBitwerxOfferingDetails(offeringId!),
    enabled: !!offeringId,
  });

  return {
    offering: query.data ?? null,
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: query.refetch,
  };
};

export default useBitwerxOfferingDetails;
